export const CLOUDINARY_BASE_URL =
    'https://res.cloudinary.com/scanandorder/image/upload';

export const BASE_URL = 'https://backbonedev.scanandorder.eu/api';
